import {CSVLink} from 'react-csv';
import moment from 'moment';

export default function CsvFromDataCtrl(props){
    const createCsvFileName = ()=> `data_${moment().format()}.csv`;

    const { headers,data } = props;
   
    
    /*const headers = [
        { label: 'Name', key: 'name' },
        { label: 'Description', key: 'description' },
        { label: 'SuggestedRoles', key: 'suggestedRoles' }
    ];

    const data = [
        {
            name: csvData.map((_)=>_.name),
            description: csvData.map((_)=>_.description),
            suggestedRoles: csvData.map((_)=>_.suggestedRoles.map((role)=>role.name)),
        }
    ];*/
    return (
        <CSVLink
            data={data}
            headers={headers}
            filename={createCsvFileName()}
            target="_blank"
            style={{ textDecoration: 'none', outline: 'none', height: '5vh',color:'black' }}
        >
            
                Generar CSV
            
        </CSVLink>
    );
}